
import * as types from '../actions/types';

const INITIAL_STATUS = {
    data: [],
    items: [],
    pageCount: 0
};

export default (state = INITIAL_STATUS, action) => {
    switch (action.type) {
        case types.RESTAURANTS_FOUND:
            return { ...action.payload };

        case types.RESTAURANTS_ITEMS:
            return { ...state, items: action.payload };

        case types.RESTAURANTS_CLEAR:
            return INITIAL_STATUS;

        default:
            return state;

    }
}